<template>
  <v-dialog
    v-model="showModal"
    :max-width="maxWidth"
    :persistent="isPersistent"
    @input="close"
  >
    <horizontal-naj-box
      :title="title"
      :sub-title="subTitle"
      header-icon="mdi-close"
      :disable-collapsing="true"
      no-bottom-margin
      has-footer
      @iconClick="close"
      :no-header="noHeader"
    >
      <div class="message">
        {{ message }}
      </div>

      <slot name="message-content" />

      <template v-slot:footer>
        <slot name="footer-content" />

        <div class="naj-modal-actions">
          <naj-button
            v-if="showCloseBtn"
            color="var(--app-error-color)"
            outlined
            @click="close"
          >
            {{ closeBtnLabel || local.common.close }}
          </naj-button>
          <naj-button
            v-if="okBtnLabel"
            :loading="actionLoading"
            @click="$emit('ok')"
          >
            {{
              okBtnLabel
            }}
          </naj-button>
          <slot name="actions" />
        </div>
      </template>
    </horizontal-naj-box>
  </v-dialog>
</template>

<script>
export default {
  name: 'NajConfirmation',
  //props: ['', '', '', '', '', '', '', '', ''],
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    okBtnLabel: {
      type: String,
      default: '',
    },
    closeBtnLabel: {
      type: String,
      default: '',
    },
    actionLoading: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: Number,
      default: 472,
    },
    isPersistent: {
      type: Boolean,
      default: true,
    },
    showCloseBtn: {
      type: Boolean,
      default: true,
      },
      noHeader: {
      type: Boolean,
      default: false,
      },
  },
  methods: {
    close() {
      this.$emit('cancel');
    },
  },
};
</script>

<style lang="scss" scoped>
.naj-modal-actions {
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  display: flex;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: flex-end;
  width: 100%;
}

    ::v-deep {
        .naj-box-header {
            padding: 25px 25px 10px 25px !important;
            background-color: #fff !important;
            border: none !important;
            direction: ltr;
            justify-content: space-between;

            .v-icon.header-icon {
                margin: 0 !important;
                border: 0.5px solid #707070;
                opacity: 0.3;
            }

            .naj-box-header-title {
                color: var(--app-dark-primary-color);
            }
        }

        .naj-box-contnet {
            padding: 20px 20px 10px 20px !important;
            border: none !important;

            .message {
                padding: 0px 43px 10px 43px;
                color: var(--app-primary-color);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
            }
        }

        .naj-box-footer {
            padding: 0 25px 25px 25px !important;
            border: none !important;
            background-color: #fff !important;
            display: block !important;

            .naj-modal-actions {
                .naj-button {
                    span {
                        padding: 10px;
                    }

                    &.v-btn--outlined {
                        border: none !important;
                    }
                }
            }
        }
    }
</style>
